export default __webpack_public_path__ + "static/media/LIQUI-1.b4023803.jpg";